import React from "react";
import { ArrowRight, ShieldCheck, Bird } from "lucide-react";
import { Link } from "react-router-dom";
import heroImage from "../assets/hero-farm.jpg";

const Hero = () => {
  return (
    <section className="relative h-screen w-full overflow-hidden flex items-center">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${heroImage})` }}
      >
        <div className="absolute inset-0 bg-[#4B3621]/40"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-transparent to-transparent"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-8 w-full">
        <div className="max-w-2xl pt-10">
          
          <div className="flex items-center gap-4 mb-6">
            <div className="h-[2px] w-8 bg-[#D4AF37]"></div>
            <span className="text-[13px] md:text-[14px] font-black uppercase tracking-[0.2em] text-[#D4AF37] drop-shadow-md">
              తాజా • శుభ్రం • నమ్మకం
            </span>
          </div>

          <h1 className="font-black text-white tracking-tight leading-normal mb-12 drop-shadow-[0_2px_10px_rgba(0,0,0,0.5)] mt-10">
            <span className="text-4xl md:text-6xl block mb-6">Guru's Farm</span>
            
            <span className="text-[#D4AF37] text-2xl md:text-4xl block leading-relaxed mb-4">
              లైవ్ నాటికోళ్లు &
            </span>
            
            <span className="text-[#4ade80] text-2xl md:text-4xl block leading-relaxed">
              లైవ్ గొర్రె (పొట్టేలు)
            </span>
          </h1>

          <div className="flex flex-wrap gap-5">
            <Link 
              to="/products" 
              className="bg-[#2D5A27] hover:bg-[#3a7332] text-white px-10 py-4 rounded-xl font-black text-[10px] uppercase tracking-widest flex items-center gap-3 transition-all shadow-lg hover:-translate-y-1"
            >
              View All Breeds 
              <ArrowRight size={16} />
            </Link>
            
            <Link 
              to="/contact" 
              className="bg-white/20 backdrop-blur-md border border-white/30 text-white px-10 py-4 rounded-xl font-black text-[10px] uppercase tracking-widest flex items-center gap-3 hover:bg-white hover:text-black transition-all"
            >
              Contact Specialist
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-10 left-8 hidden md:flex gap-10 text-white/60">
        <div className="flex items-center gap-3">
          <ShieldCheck size={18} className="text-[#D4AF37]" />
          <span className="text-[9px] font-black uppercase tracking-widest drop-shadow-sm">Purebred Genetic Stock</span>
        </div>
        <div className="flex items-center gap-3 border-l border-white/20 pl-10">
          <Bird size={18} className="text-[#4ade80]" />
          <span className="text-[9px] font-black uppercase tracking-widest drop-shadow-sm">Elite Layer Strains</span>
        </div>
      </div>
    </section>
  );
};

export default Hero;